module.exports = __webpack_public_path__ + "static/media/BANNERS-POR-SECCIONES-bolsa-de-trabajo.a29d2039.png";